module.exports = "/images/vendor/flag-icon-css/flags/4x3/iq.svg?be9919971db8b464b1baf82a3873d1ab";